import type { Dispatch, SetStateAction } from 'react';
import { useState, useCallback } from 'react';

export type UseBooleanReturn = [
  boolean,
  () => void,
  () => void,
  () => void,
  Dispatch<SetStateAction<boolean>>,
];

export const useBoolean = (initialValue = false): UseBooleanReturn => {
  const [value, setValue] = useState(initialValue);

  const toggle = useCallback(() => setValue((val) => !val), []);
  const setTrue = useCallback(() => setValue(true), []);
  const setFalse = useCallback(() => setValue(false), []);

  return [value, toggle, setTrue, setFalse, setValue];
};
